import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { BaseItemComponent } from '../base-item/base-item.component';
import { CartItem } from '../../../models/cart-item.model';

@Component({
  selector: 'usb-experience-item',
  templateUrl: './experience-item.component.html',
  styleUrls: ['./experience-item.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})

export class ExperienceItemComponent extends BaseItemComponent {
  @Input() item: any;
  @Input() clientsSettingAppBooking: any;

  getDurationTour (): string {
    if(this.item.scheduling && Array.isArray(this.item.scheduling) && this.item.scheduling.length > 0) {
      return `${this.item.scheduling[0]?.duration?.value} ${this.item.scheduling[0]?.duration?.metric === 'HOURS' ? 'horas.' : 'minutos.'}`;
    }

    return 'No disponible';
  }
}
